<template>
  <vs-wrapper v-if="isError || (!isLoading && hasReferences)">
    <v-row align="center">
      <v-col class="grow">
        <vs-heading type="overline">Links</vs-heading>
      </v-col>
    </v-row>
    <vs-wrapper v-if="isError" space="small">
      <v-alert dense outlined shaped type="error"> Unable to load links </v-alert>
    </vs-wrapper>
    <vs-wrapper v-else space="small">
      <v-row
        v-for="reference in referenceList"
        :key="reference.id"
        justify="space-between"
        data-test="link-list"
      >
        <v-col cols="9">
          <vs-text class="truncate">
            <a
              :href="reference.url"
              target="_blank"
              rel="noopener noreferrer"
              class="text-decoration-underline"
            >
              <v-icon size="medium">mdi-open-in-new</v-icon>
              {{ reference.referencedId }}
            </a>
          </vs-text>
        </v-col>
        <v-col cols="3" data-test="link-type" class="text-right">
          <vs-text>{{ getReferenceTypeString(reference.referenceType) }}</vs-text>
        </v-col>
      </v-row>
    </vs-wrapper>
  </vs-wrapper>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsHeading from '@/components/vision/VsHeading.vue'
import VsText from '@/components/vision/VsText.vue'
import { useGetJobReferencesQuery } from '@/api/jobs'

const props = defineProps<{
  jobId: string
}>()

const { data: references, isLoading, isError } = useGetJobReferencesQuery(props.jobId)
const referenceList = computed(
  () => references.value?.filter((reference) => reference.url !== null) ?? [],
)
const hasReferences = computed(() => referenceList.value.length > 0)

function getReferenceTypeString(referenceType: string) {
  switch (referenceType) {
    case 'oplii':
      return 'Oplii'
    case 'emaint':
      return 'eMaint'
    case 'open_ticket':
      return 'OpenTicket'
    case 'kabal':
      return 'Kabal'
    case 'wiq':
      return 'WiQ'
    case 'jd_edwards':
      return 'JD Edwards'
    case 'quickbooks_online':
      return 'QuickBooks Online'
    default:
      return ''
  }
}
</script>

<style scoped>
a .v-icon {
  color: var(--text-color);
  vertical-align: middle;
}
</style>
